var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-textarea',{staticClass:"textarea-field",attrs:{"placeholder":_vm.$t('applications.type')+' '+_vm.placeholder},on:{"input":_vm.handleTextareaInput},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})
}
var staticRenderFns = []

export { render, staticRenderFns }